import type { Message, MessageAttachment } from '../types';

/** Same as the bucket lifecycle rule (chatFiles.service.ts). */
export const CHAT_FILE_RETENTION_DAYS = 30;
export const CHAT_FILE_MAX_BYTES = 10 * 1024 * 1024; // same as chatFiles.service.ts

export const isGif = (attachment?: MessageAttachment | null) => !!attachment?.gif;
/** An uploaded picture (a built-in GIF is not one — it has no file in S3). */
export const isImage = (attachment?: MessageAttachment | null) =>
    !isGif(attachment) && !!attachment?.type?.startsWith('image/');

export const isFileExpired = (createdAt?: string) =>
    !!createdAt && Date.now() - new Date(createdAt).getTime() > CHAT_FILE_RETENTION_DAYS * 86_400_000;

export const formatBytes = (bytes: number) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/** One-line text for chat list, reply quotes and pop-ups: the caption, else what the file is. */
export const previewText = (msg?: Pick<Message, 'message' | 'attachment'> | null) => {
    if (!msg) return '';
    if (msg.message?.trim()) return msg.message;
    if (isGif(msg.attachment)) return '🎞️ GIF';
    if (msg.attachment) return isImage(msg.attachment) ? '📷 Photo' : `📎 ${msg.attachment.name}`;
    return '';
};
